module.exports = __webpack_public_path__ + "img/202502_04.33093464.jpg";